import React from 'react'
import { useModal } from '../../hooks/modal'
import { useDeleteRequest } from '../../hooks/request'
import { ENTRANCE_DETAIL } from '../../urls'
import EntranceUpdate from './EntranceUpdate'
import Button from '../../components/common/Button'

export default function EntranceItem({ item, entrance, index }) {
    const productRemove = useDeleteRequest({ url: ENTRANCE_DETAIL.replace('{id}', item.id) })

    async function onDelete() {
        if (global.confirm('Вы действительно хотите удалить?')) {
            await productRemove.request()
            entrance.request()
        }
    }

    const [showUpdateModal, hideUpdateModal] = useModal(
        <EntranceUpdate
            clients={item}
            item={item}
            onCancel={() => {
                entrance.request()
                hideUpdateModal()
            }}
        />,
    )

    return (
        <tr className=" is-size-6" key={item.id}>
            <td className="is-size-6">{index + 1}</td>
            <td className="is-size-6">{(item.selectBuilding?.name)}</td>
            <td className="is-size-6">{(item.entranceNumber)}</td>
            <td>
                <div style={{ display: 'flex' }} className="has-text-right">
                    <Button onClick={showUpdateModal} className="mr-2 button is-success is-outlined is-small"
                        icon="pencil-outline" />
                    <Button onClick={onDelete} className="button is-danger mr-2 is-outlined is-small" icon="trash" />
                </div>
            </td>
        </tr>

    )
}
